module.exports = __webpack_public_path__ + "static/media/blueCalendar.f7970ffc.svg";